import request from '../utils/request'
export default {
  login (data) {
    return request({
      url: '/webApi/login',
      method: 'POST',
      data: { ...data }
    })
  },
  tradeConfigList (data) {
    return request({
      url: '/webApi/TradeCoinConfigs',
      method: 'GET',
      params: { ...data }
    })
  },
  tradeConfigEnable (data) {
    return request({
      url: '/webApi/TradeCoinConfigEnable',
      method: 'GET',
      params: { ...data }
    })
  },
  tradeConfigSave (data) {
    return request({
      url: '/webApi/TradeCoinConfigSave',
      method: 'POST',
      data: { ...data }
    })
  },
  tradeConfigDel (data) {
    return request({
      url: '/webApi/TradeCoinConfigDel',
      method: 'GET',
      params: { ...data }
    })
  },
  okxInstrumentsOpts (data) {
    return request({
      url: '/webApi/okx/instrumentsOpts',
      method: 'GET',
      params: { ...data }
    })
  },
  markPrice (data) {
    return request({
      url: '/webApi/platform/markPrice',
      method: 'GET',
      params: { ...data }
    })
  },
  triggerLevelSave (data) {
    return request({
      url: '/webApi/TriggerStrategySave',
      method: 'POST',
      data: { ...data }
    })
  },
  triggerLevelEnable (data) {
    return request({
      url: '/webApi/TriggerStrategyEnable',
      method: 'GET',
      params: { ...data }
    })
  },
  triggerLevelDel (data) {
    return request({
      url: '/webApi/TriggerStrategyDel',
      method: 'GET',
      params: { ...data }
    })
  },
  platformTradePairs (data) {
    return request({
      url: '/webApi/platform/tradePairs',
      method: 'GET',
      params: { ...data }
    })
  },
  globbingKlineConfigList (data) {
    return request({
      url: '/webApi/KlineGlobbingConfigs',
      method: 'GET',
      params: { ...data }
    })
  },
  globbingKlineConfigEnable (data) {
    return request({
      url: '/webApi/KlineGlobbingConfigsEnable',
      method: 'GET',
      params: { ...data }
    })
  },
  globbingKlineConfigNoticeEnable (data) {
    return request({
      url: '/webApi/KlineGlobbingConfigsNoticeEnable',
      method: 'GET',
      params: { ...data }
    })
  },
  globbingConfigSave (data) {
    return request({
      url: '/webApi/KlineGlobbingConfigSave',
      method: 'POST',
      data: { ...data }
    })
  },
  globbingConfigDel (data) {
    return request({
      url: '/webApi/KlineGlobbingConfigsDel',
      method: 'GET',
      params: { ...data }
    })
  },
  // K线波动配置相关API
  klineWaveConfigsList (data) {
    return request({
      url: '/webApi/KlineWaveConfigs',
      method: 'GET',
      params: { ...data }
    })
  },
  klineWaveConfigsSave (data) {
    return request({
      url: '/webApi/KlineWaveConfigsSave',
      method: 'POST',
      data: { ...data }
    })
  },
}
